<template>
  <div>
    <div v-if="isUnintrusive">
      <cookie-disclaimer
        v-if="displayConsentBanner"
        @consent-all="() => $emit('consent-all', consentPayload) && trackConsent()"
        @reject-all="() => $emit('reject-all', consentPayload) && trackConsent()"
        @open-settings="openSettings"
        :is-banner="true"
      />
      <modal
        id="cookie-banner"
        :show="displaySettingsModal && displayConsentBanner"
        @close="closeSettings"
        :has-close-button="true"
        :close-on-background-click="true"
        :modifiers="['rounded-border', 'grey-pale']"
        :close-on-escape="true"
        tracking-name="popup-20200728-cookie-banner"
      >
        <cookie-settings
          @consent-all="() => $emit('consent-all', consentPayload) && trackConsent()"
          @consent="(options) => $emit('consent', { ...consentPayload, ...options }) && trackConsent()"
        />
      </modal>
    </div>
    <modal
      v-else
      id="cookie-banner"
      :show="displayConsentBanner"
      :has-close-button="false"
      :close-on-background-click="false"
      :modifiers="['rounded-border', 'grey-pale']"
      :close-on-escape="false"
      tracking-name="popup-20200728-cookie-banner"
    >
      <template v-slot:disclaimer>
        <cookie-disclaimer
          @consent-all="() => $emit('consent-all', consentPayload) && trackConsent()"
          @reject-all="() => $emit('reject-all', consentPayload) && trackConsent()"
        />
      </template>
      <template v-slot:settings>
        <cookie-settings
          @consent-all="() => $emit('consent-all', consentPayload) && trackConsent()"
          @consent="(options) => $emit('consent', { ...consentPayload, ...options }) && trackConsent()"
        />
      </template>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Modal from "@/shared/modal"
import CookieDisclaimer from "./cookie-disclaimer"
import CookieSettings from "./cookie-settings"
import { posthog } from "posthog-js"

export default {
  name: "CookieBanner",
  components: {
    Modal,
    CookieDisclaimer,
    CookieSettings
  },
  data() {
    return {
      displaySettingsModal: false
    }
  },
  computed: {
    ...mapGetters(["displayConsentBanner"]),
    isUnintrusive() {
      const urlParams = new URLSearchParams(window.location.search)

      return urlParams.get("consent") === "ni"
    },
    consentType() {
      return this.isUnintrusive ? "unintrusive" : "intrusive"
    },
    consentPayload() {
      return {
        consentType: this.consentType
      }
    }
  },
  methods: {
    openSettings() {
      this.displaySettingsModal = true
    },
    closeSettings() {
      this.displaySettingsModal = false
    },
    trackConsent() {
      /**
       * Temporarily assess how many users still see the banner after consenting (bug)
       * Set timeout allows time for cookiebot event to fire
       * which should trigger displayConsentBanner to be set to false
       */
      setTimeout(() => {
        posthog.capture("cookie_consent_debug_submit", {
          display: this.displayConsentBanner
        })
      }, 3500)
    }
  }
}
</script>
